<style scoped>
input[type="file"] {
  display: none;
}
</style>

<template>
  <span>
    <crud-button
      large
      color="green"
      @clicked="openFileUpload()"
      icon="fa-file-import"
      :tooltip="$t('global.crud.buttons.import')"
    />
    <input
      type="file"
      ref="file"
      id="fileUpload"
      accept=".xls,.xlsx"
      v-on:change="doImport()"
    />
    <v-snackbar
      v-model="importOK"
      :top="true"
      :right="true"
      color="blue"
      :timeout="2000"
    >
      {{ $t("import.ok") }}
    </v-snackbar>
    <v-dialog v-model="dialog" hide-overlay persistent width="300">
      <v-card color="blue" dark>
        <v-card-text>
          {{ $t("import.loading") }}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import localhttp from "../js/https-commons";
import CrudButton from "@/components/Button.vue";
import XLSX from "xlsx";

export default {
  components: {
    CrudButton
  },
  data: () => ({
    importOK: false,
    dialog: false
  }),
  props: {
    url: {
      type: String
    },
    maxItems: {
      type: Number,
      default: 1000
    },
    filterImport: { type: Function }
  },
  methods: {
    openFileUpload() {
      this.$refs.file.click();
    },
    doImport() {
      var fileReader = new FileReader();
      fileReader.onload = function(event) {
        var data = event.target.result;

        var workbook = XLSX.read(data, {
          type: "binary"
        });
        workbook.SheetNames.forEach(sheet => {
          let rowObject = XLSX.utils.sheet_to_row_object_array(
            workbook.Sheets[sheet]
          );
          //max items control
          if (rowObject.length > vm.maxItems) {
            vm.$showErrorMessage(
              vm.$t("global.crud.buttons.import.maxItems", {
                maxItems: vm.maxItems
              })
            );
            return;
          }

          //filter data
          //console.log(rowObject);
          vm.globalFilterImport(rowObject);
          if (vm.filterImport != undefined) {
            vm.filterImport(rowObject);
          }

          //import post
          vm.dialog = true;
          localhttp
            .post(vm.url + "/import", rowObject)
            // eslint-disable-next-line no-unused-vars
            .then(response => {
              vm.dialog = false;
              vm.importOK = true;
              vm.$emit("done");
            })
            .catch(e => {
              vm.dialog = false;
              console.log(e);
              if (e.response.data.message === undefined) {
                vm.$showErrorCode(e.response.status);
              } else {
                vm.$showErrorMessage(e.response.data.message);
              }
            });
          vm.$refs.file.value = "";
        });
      };

      var vm = this;
      this.selectedFile = this.$refs.file.files[0];
      fileReader.readAsBinaryString(this.selectedFile);
    },
    globalFilterImport(jsonData) {
      jsonData.forEach(function(v) {
        //timestamp of deletion date when true
        if (v.deletionDate !== undefined) {
          if (v.deletionDate !== null && v.deletionDate === true) {
            v.deletionDate = Date.now();
          } else {
            v.deletionDate = null;
          }
        }
      });
    }
  }
};
</script>
